import React, { useState, useEffect } from 'react';

const CookiesPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false); // State for cookie settings

  useEffect(() => {
    // Check if the user has already accepted or declined cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    // Store the user's acceptance in localStorage
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    // Simply hide the popup without storing anything
    setIsVisible(false);
  };

  const toggleSettings = () => {
    setIsSettingsOpen(!isSettingsOpen); // Toggle the settings section
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 bg-white text-gray-800 rounded-lg shadow-lg p-6 w-11/12 max-w-sm z-50">
      <h2 className="text-lg font-bold mb-2">We Value Your Privacy</h2>
      <p className="text-sm mb-4">
        We use cookies to improve your experience on our site. By using our site, you consent to cookies.{' '}
        {/* <a href="/privacy-policy" className="underline text-blue-600 hover:text-blue-800">
          Learn more
        </a>. */}
      </p>

      {/* Cookie Settings Section */}
      {isSettingsOpen && (
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <h3 className="text-md font-semibold mb-2">Cookie Preferences</h3>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span>Necessary Cookies</span>
              <span className="text-sm text-gray-500">Always Active</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Analytics Cookies</span>
              <input type="checkbox" className="form-checkbox h-5 w-5 text-blue-600" />
            </div>
            <div className="flex items-center justify-between">
              <span>Advertisement Cookies</span>
              <input type="checkbox" className="form-checkbox h-5 w-5 text-blue-600" />
            </div>
            <div className="flex items-center justify-between">
              <span>Functionality Cookies</span>
              <input type="checkbox" className="form-checkbox h-5 w-5 text-blue-600" />
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-end space-x-4">
        <button
          onClick={toggleSettings}
          className="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-lg text-sm font-semibold transition"
        >
          Cookie Settings
        </button>
        <button
          onClick={handleDecline}
          className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition"
        >
          Decline
        </button>
        <button
          onClick={handleAccept}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookiesPopup;